import React, {Component, Fragment} from 'react';
import ReactDOM from 'react-dom';
import { Input } from './FormUI';
import { BioTrackPortal } from './BiopedUI';

import List from 'react-list-select';

import './AutoCompleteInput.css';
import { isElementUnderPoint } from '../common';

export default class AutoCompleteInput extends Component{
	state = {};
	labelRef = null;
	listRef = null;
	listDom = null;
	inputRef = null;
	optionDoms = [];


	handleRef = (dom, r)=>{
		this.labelRef = dom;
		this.inputRef = r;
	}

	handleListRef = (r) =>{
		this.listRef = r;
		this.listDom = ReactDOM.findDOMNode(r);
		console.log("List Ref:", this.listRef);
		if(r)r.focusIndex(0);
	}

	posFunc = (style, bounds) => {
		style.width = bounds.width + 'px';
	}


	renderOptions(){
		let options = this.state.options || [];
		let optionDoms = [];

		let ro = [];
		let start = 0;
		if(this.props.isCreatable){
			ro.push(<div key={0} ref={(r) =>{optionDoms.push(r)}} >{this.createRenderer(this.nextVal)}</div>);
			start++;
		}
		for(let i=0; i < options.length; i++){
			let index = i + start;
			ro.push(<div key={index} ref={(r) =>{optionDoms.push(r)}} >{this.optionRenderer(options[i], i, this.state.filter)}</div>);
		}

		this.optionDoms = optionDoms;
		return ro;
	}

	_optionRenderer(item){
		return item;
	}
	_noResultRender(){
		return 'No Results';
	}
	get loadOptions(){
		return this.props.loadOptions || this._getOptions;
	}
	get noResultRender(){
		return this.props.noResultRender || this._noResultRender;
	}

	get optionRenderer(){
		return this.props.optionRenderer || this._optionRenderer;
	}

	get valueRenderer(){
		return this.props.valueRenderer || this._valueRenderer;
	}

	get createRenderer(){
		return this.props.createRenderer || this._createRenderer
	}
	_createRenderer(val){
		return <span className='auto-complete-create-new'>Create New: {val}</span>;
	}

	_valueRenderer(val){
		return val;
	}

	get isBusy(){
		return this._isBusy;
	}
	set isBusy(val){
		this._isBusy = val;
		this.setState({isBusy:val});
	}



	handleInputChange = (val) => {
		this.nextVal = val;
		if(this.isBusy)return;
		this.isBusy = true;
		//this.setState({isBusy:true})
		this.loadOptions(val).then((options) => {
			this.isBusy = false;
			if(this.nextVal.trim().toLowerCase() != val.trim().toLowerCase()){
				this.handleInputChange(this.nextVal);
			}else{
				let isVisible = ((options.length > 0 && val.length > 0) || (val.length > 0 && this.props.isCreatable));
				this.setState({options:options, listVisible:isVisible, filter:val});
			}
		});
	}


	_getOptions(val){
		let opts = [];
		for(let i=0; i < 100; i++){
			opts.push('Option ' + i)
		}
		return Promise.resolve(opts);
	}

	handleListChange = (index)=>{
		if(this.props.isCreatable && index === 0){
			if(this.props.onNewOptionClick){
				this.props.onNewOptionClick(this.nextVal);
			}
		}else{

			if(this.props.isCreatable){
				index--;
			}

			let option = this.state.options[index];
			this.inputRef._onValueChanged(this.valueRenderer(option), true);
			this.setState({selected:option});
			if(this.props.onOptionSelect){
				this.props.onOptionSelect(option);
			}
		}

		this.setState({listVisible:false});
	}

	setOption = (option)=>{
		this.inputRef._onValueChanged(this.valueRenderer(option), true);
		this.setState({selected:option});
	}


	handleKeyDown = (e)=>{
		if(!this.listRef)return;
		let code = e.keyCode;
		let up = 38;
		let down = 40;
		let enter = 13
		let index = this.listRef.state.focusedIndex;
		switch(code){
		case up:
			this.listRef.focusPrevious();
			index--;
			break;
		case down:
			this.listRef.focusNext();
			index++;
			break;
		case enter:
			this.handleListChange(index);
			break;
		}


		if(index < 0)index = this.optionDoms.length - 1;
		if(index >= this.optionDoms.length) index = 0;

		let dom = this.optionDoms[index];

		if(dom){
			dom.scrollIntoView(false);
		}

	}



	handleOnBlur = (e) => {
		//this.setState({listVisible:false});
		if(this.props.onBlur){
			this.props.onBlur(e);
		}
	}

	handleClickOutside = (x, y) => {
		if(!isElementUnderPoint(this.labelRef, x, y))this.setState({listVisible: false});
	}



	render(){
		let {onChange, onBlur,  ...props} = this.props;
		let openClass = this.state.listVisible? ' list-open':'';
		return(
			<Fragment>
				<Input className={'input-autocomplete' + openClass} onDom={this.handleRef} autoComplete='off' autoCorrect='off' spellCheck='off' onChange={this.handleInputChange} onKeyDown={this.handleKeyDown} onBlur={this.handleOnBlur} isBusy={this.isBusy} {...props} />
				<BioTrackPortal className="auto-complete-menu" target={this.labelRef} isVisible={this.state.listVisible} posFunc={this.posFunc} onClickOutside={this.handleClickOutside}>
					<List className='input-dropdown' items={this.renderOptions()} onChange={this.handleListChange} ref={this.handleListRef} />
				</BioTrackPortal>
			</Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AutoCompleteInput.js